<template>
    <div class="date-picker-global"  :class="{mini:mini, isOpen:showPicker}">
        <input class="date-picker-handler" :class="inputclass" ref="date" type="text" v-model="formatedSelected" v-inputmask="maskFromTrad" @click="handlePicker" @keyup="handleInput"/>
        <div class="date-picker-container" :class="[constructPositionClasses,{show:showPicker}]" v-on-clickaway="unhandlePicker">
            <div class="date-display">
                {{ formatedDisplay }}
            </div>
            <div class="date-picker" :id="'picker-'+_uid"></div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import rome from 'rome'
    import Utils from '@/services/utils'
    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        components: {},
        computed: {
            formatedSelected: function(){
                return this.selected.format(Utils.t('datetime.date'));
            },
            formatedDisplay: function(){
                return this.selected.format(Utils.t('datetime.dateText'));
            },
            constructPositionClasses: function(){
                if(this.position.v != 'top' && this.position.v != 'bottom'){
                    this.position.v = 'top';
                }
                if(this.position.h != 'left' && this.position.h != 'right' && this.position.h != 'center'){
                    this.position.h = 'right';
                }
                return 'vpos-'+this.position.v+' hpos-'+this.position.h;
            },
            maskFromTrad(){
                return Utils.t('datetime.mask')
            }
        },
        created: function () {

        },
        data () {
            return {
                showPicker: false,
                selected: moment(),
                minDate: null,
                maxDate: null,
                rome: null,
                romeOptions: {
                    initialValue: this.selected,
                    time: false,
                    min: this.minDate,
                    max: this.maxDate
                },
                firstTime: true
            }
        },
        destroyed: function () {

        },
        methods: {
            handlePicker: function () {
                this.$refs.date.select();
                this.showPicker = true;
                this.firstTime = true;
            },
            unhandlePicker: function () {

                if(!this.firstTime){
                    this.showPicker = false;
                }
                this.firstTime = false;
            },
            handleInput: function(){
                if(this.$refs.date.value.indexOf('_') == -1){
                    var date = moment(this.$refs.date.value,Utils.t('datetime.date'));
                    if(date.isValid()){
                        this.selected = date;
                        this.rome.setValue(date);
                    }
                }


            },

            initSelected: function(value){
                if (value != null) {
                    this.selected = value;
                }
                else{

                    this.selected = moment();
                }
            },
            initMin: function(value){
                this.minDate = value;
                this.romeOptions.min = this.minDate;
            },
            initMax: function(value){
                this.maxDate = value;
                this.romeOptions.max = this.maxDate;
            },
        },
        mixins: [clickaway],
        mounted: function () {

            this.initSelected(this.value);
            this.initMin(this.min);
            this.initMax(this.max);

            var pickerContainer = document.getElementById('picker-'+this._uid);
            this.rome = rome(pickerContainer,this.romeOptions).on('data',date => {
                this.selected = moment(date);
                this.$emit('input',this.selected);
            });
        },
        name: '',
        props: {
            value: {
                type: Object,
                default: moment()
            },
            min: {
                type: Object,
                default: null
            },
            max: {
                type: Object,
                default: null
            },
            inputclass: {
                type: String,
                default: ''
            },
            mini: {
                type: Boolean,
                default: false
            },
            position: {
                type: Object,
                default: function(){
                    return {
                        v: 'top',
                        h: 'right'
                    }
                }
            }
        },
        updated: function () {

        },
        watch: {
            value: function (newValue) {
                this.initSelected(newValue);
            },
            min: function(newValue){
                this.initMin(newValue);
                this.romeOptions.min = this.minDate;
                this.rome.restore(this.romeOptions);
            },
            max: function(newValue){
                this.initMax(newValue);
                this.romeOptions.max = this.maxDate;
                this.rome.restore(this.romeOptions);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>